export default __webpack_public_path__ + "img/orderNotFound.b9ef66b90ef91e43e9911b2a585eb280.svg";